
import { Component, Injector, Input, OnInit } from '@angular/core';
import {
	ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextControlSchema,
	SwitchControlSchema, DateTimeControlSchema
} from 'tnx-shared';
import { WorkflowStepService } from 'tnx-admin-service/workflowcore/workflowstep/services';

@Component({
	selector: 'workflowstep-form',
	templateUrl: './workflowstep-form.component.html',
	styleUrls: ['./workflowstep-form.component.scss'],
	providers: [ComponentContextService],
})
export class WorkflowStepFormComponent extends DataFormBase implements OnInit {

	constructor(
		protected _injector: Injector,
		private _workflowStepService: WorkflowStepService
	) {
		super(_injector);
	}

	ngOnInit() {
		super.ngOnInit();
		this.setting.baseService = this._workflowStepService;
		this.setting.schema = <FormSchemaBase[]>[
			new TextControlSchema({
				field: 'longId',
				label: ''
			}),
			new DateTimeControlSchema({
				field: 'createTime',
				label: ''
			}),
			new TextControlSchema({
				field: 'stepId',
				label: ''
			}),
			new TextControlSchema({
				field: 'stepCode',
				label: ''
			}),
			new TextControlSchema({
				field: 'status',
				label: ''
			}),
			new TextControlSchema({
				field: 'workflowDefinitionId',
				label: ''
			}),
			new TextControlSchema({
				field: 'stepType',
				label: ''
			}),
			new TextControlSchema({
				field: 'httpRequest',
				label: ''
			}),
			new TextControlSchema({
				field: 'deadline',
				label: ''
			}),
			new SwitchControlSchema({
				field: 'isDate',
				label: ''
			}),
			new TextControlSchema({
				field: 'persistenceId',
				label: ''
			}),
			new TextControlSchema({
				field: 'stepName',
				label: ''
			}),
			new SwitchControlSchema({
				field: 'autoFinish',
				label: ''
			}),
			new TextControlSchema({
				field: 'key',
				label: ''
			}),
			new TextControlSchema({
				field: 'value',
				label: ''
			}),
			new TextControlSchema({
				field: 'currentStateCode',
				label: ''
			}),
			new TextControlSchema({
				field: 'code',
				label: ''
			})
		];
	}

	async onFormInitialized(formEvent: EventData) {
		// tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
	}

	async onFormEvent(evt) {
		// các event trong form
		console.log(evt);
	}

	async modifyDetailData(data) {
		// xử lý dữ liệu lấy từ get detail về
	}

	async onAfterGetDetail() {
		// xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
	}

	onBeforeSave() {
		// trước khi lưu
	}
}

